<template lang="pug">
.skeleton(v-if="destroy" ref="containes")
  .skeleton-remove-after-first-request
  .skeleton-container-remove-after-first-request(ref="container")
</template>

<script>
import { SkeletonMap } from '@/const/skeletonMap';
import { isPreRender } from '@/utils';

export default {
  data() {
    return {
      destroy: false,
    };
  },
  mounted() {
    if (isPreRender()) {
      this.init();
      return;
    }
    this.removeSkeleton();
  },
  methods: {
    async init() {
      const { path: a = '/', query: c = {} } = this.$route;
      // eslint-disable-next-line no-unused-expressions
      Object.keys(SkeletonMap).some(async (k) => {
        const { pathname, query: t } = this.o(k);
        if (
          pathname === a
          && t
          && c
          && Object.keys(t).every((v) => t[v] === c[v])
        ) {
          this.destroy = true;
          this.$nextTick(() => {
            const { container: r } = this.$refs;
            if (r) {
              r.style.setProperty(
                'background-image',
                `url("${SkeletonMap[a]}")`,
                'important',
              );
            }
          });
          return true;
        }
        return false;
      }) || this.removeSkeleton();
    },
    r(e) {
      const t = e.replace(/\+/g, ' ');
      try {
        return decodeURIComponent(t);
      } catch (err) {
        return t;
      }
    },
    o(e) {
      const tmp = e && /^#?(\/[^?\s]*)(\?[^\s]*)?$/.exec(e);
      const param = tmp
        ? {
          pathname: tmp[1],
          query:
              tmp[2] && typeof tmp[2] === 'string'
                ? tmp[2]
                  .replace(/^\?/, '')
                  .split('&')
                  .reduce((v, t) => {
                    const n = t.indexOf('=');
                    const o = { ...v };
                    if (n === -1) {
                      o[this.r(t)] = '';
                    } else {
                      o[this.r(t.slice(0, n))] = this.r(t.slice(n + 1));
                    }
                    return o;
                  }, {})
                : {},
        }
        : {
          pathname: '/',
          query: {},
        };
      return param;
    },
    removeSkeleton() {
      this.destroy = false;
    },
  },
};
</script>

<style lang="less" scoped>
@keyframes flush {
  0% {
    left: -100%;
  }

  50% {
    left: 0;
  }

  100% {
    left: 100%;
  }
}

.skeleton-remove-after-first-request {
  animation: flush 2s linear infinite;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 9999;
  background:
    linear-gradient(
      to left,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 100%
    );
}

.skeleton-container-remove-after-first-request {
  position: absolute;
  inset: 0;
  z-index: 9998;
  background-repeat: no-repeat !important;
  background-size: 100% !important;
  background-color: rgb(255, 255, 255) !important;
  background-position: center 0 !important;
}
</style>
